"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _CodeEditor = _interopRequireDefault(require("@insided/shared/uikit/CodeEditor"));

var CustomHeader = function CustomHeader(_ref) {
  var html = _ref.html,
      _onChange = _ref.onChange;
  return (0, _preact.h)("div", null, (0, _preact.h)("strong", null, "Custom HTML"), (0, _preact.h)("p", null, "We recommend inviting a professional web developer to work with custom code. Insert code at your own risk, and proceed with extreme caution - inSided support won't be able to assist you with custom code issues. If you want to test your code before publishing we strongly recommend you to use your staging environment first."), (0, _preact.h)(_CodeEditor.default, {
    defaultValue: html,
    onChange: function onChange(newCode) {
      return _onChange({
        html: newCode
      });
    },
    className: "customCss__form-textarea"
  }));
};

var _default = CustomHeader;
exports.default = _default;